import {SleepFragments} from '../animations/SleepFragments';
import {ScienceScreen} from './ScienceScreen';

export const BargainingScience = () => (
  <ScienceScreen
    headline="You control when you try to sleep. The apnea decides whether you wake up rested."
    body={
      <>
        <p>
          <strong>Apnea events fragment your sleep all night, every night.</strong> The hours you spend in bed don't
          translate into hours your body actually recovers.
        </p>
        <p>
          <strong>Stricter bedtime sets when you sleep.</strong> It doesn't change what your airway does during it.
        </p>
      </>
    }
    animation={<SleepFragments />}
    callout="We work on the underlying apnea events themselves — not just the timing of your routines."
    analyticsShown="GLP-1 Funnel Grief Bargaining Science Viewed"
    analyticsSubmitted="GLP-1 Funnel Grief Bargaining Science Submitted"
  />
);

export default BargainingScience;
